/**
 * System Health — placeholder page.
 *
 * Wired into the admin SPA at /monitoring/system-health with a SUPER_ADMIN
 * gate so the route is reachable today. The actual system-health view
 * (uptime, latency, queue depth, error rates) is intentionally deferred —
 * this page exists to anchor the Monitoring sidebar group and reserve the URL.
 */
import React from 'react';
import { Activity } from 'lucide-react';
import { SecurityBoundary } from '@vehix/portal/lib/security';
import { SystemRole } from '@vehix/portal/types';

const SystemHealthPage: React.FC = () => {
  return (
    <SecurityBoundary
      requiredSystemRole={SystemRole.SUPER_ADMIN}
      auditPageAccess='system-health'
      tenantIsolation={false}
    >
      <div className='flex h-full w-full items-center justify-center p-8'>
        <div className='max-w-md text-center space-y-4'>
          <div className='mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-muted'>
            <Activity className='h-8 w-8 text-muted-foreground' />
          </div>
          <h1 className='text-2xl font-bold tracking-tight'>System Health</h1>
          <p className='text-sm text-muted-foreground'>
            Coming soon. This page will report platform-wide health: uptime,
            latency, queue depth, and error rates across all subsystems.
          </p>
        </div>
      </div>
    </SecurityBoundary>
  );
};

export default SystemHealthPage;
